import {useEffect, useState} from 'react';

import {getSupportedUserAuditActions} from 'src/openapi/admin/apis/DictionaryApi';
import {useAppDispatch} from 'src/store/hooks';

export type DicItem = {
    id: string,
    title: string,
};

type UseSupportedUserAuditActionsReturn = {
    actionOptions: DicItem[],
    getTitleById: (id: string) => string | undefined,
};

export function useSupportedUserAuditActions(userId: number): UseSupportedUserAuditActionsReturn {
    const dispatch = useAppDispatch();
    const [actionOptions, setActionOptions] = useState<DicItem[]>([]);

    useEffect(() => {
        const controller = new AbortController();

        (async () => {
            try {
                const response = await dispatch(
                    getSupportedUserAuditActions({userId}, {signal: controller.signal}),
                );
                if (controller.signal.aborted) {
                    return;
                }
                if (response.payload?.success) {
                    setActionOptions(
                        response.payload.data
                            .flatMap(item => item.children ?? [])
                            .map(opt => ({id: opt.id, title: opt.description ?? opt.id})),
                    );
                }
            } catch {
                // non-critical — filter just won't have options
            }
        })();

        return () => {
            controller.abort();
        };
    }, [dispatch, userId]);

    const getTitleById = (id: string): string | undefined =>
        actionOptions.find(item => item.id === id)?.title;

    return {actionOptions, getTitleById};
}
